<template>
  <div class="confirmation-modal">
    <div class="modal-content bg-white shadow-lg">
      <div
        class="header p-5 text-white text-center uppercase bg-red"
        v-if="headerText"
      >
        <i class="far fa-exclamation-triangle mr-2 text-3xl" />
        <span class="text-lg">{{ headerText }}</span>
      </div>
      <div class="body" v-if="bodyComponent">
        <component :is="bodyComponent" v-bind.sync="bodyComponentData" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ConfirmationModal",
  computed: {
    type() {
      return this.$store.state.ConfirmationModal.type;
    },
    headerText() {
      return this.$store.state.ConfirmationModal.headerText;
    },
    bodyComponent() {
      return this.$store.state.ConfirmationModal.bodyComponent;
    },
    bodyComponentData() {
      return this.$store.state.ConfirmationModal.bodyComponentData;
    }
  }
};
</script>

<style lang="scss" scoped>
.confirmation-modal {
  display: block;

  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  width: 100vw;
  height: 100vh;

  background-color: rgba(0, 0, 0, 0.4);

  z-index: 99;

  .modal-content {
    position: fixed;
    top: 50%;
    width: calc(100% - 1.5rem);
    transform: translateY(-50%);

    @apply mx-3;

    @screen md {
      width: auto;
      left: 50%;
      transform: translate(-50%, -50%);
      @apply mx-0;
    }
  }
}
</style>
